(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rcl-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const button = document.getElementById('rcl-chat-launcher');
  const panel = document.getElementById('rcl-chat-panel');
  const close = document.getElementById('rcl-chat-close');
  const status = document.getElementById('rcl-chat-status');
  if (!button || !panel) return;
  let timer;
  const hide = () => {
    panel.hidden = true;
    button.hidden = false;
    button.setAttribute('aria-expanded', 'false');
    button.focus();
    clearTimeout(timer);
  };
  const ready = () => {
    const api = window.HubSpotConversations;
    if (!api || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.hidden = false;
    api.on('widgetLoaded', () => { status.hidden = true; clearTimeout(timer); });
    button.addEventListener('click', () => {
      panel.hidden = false;
      button.hidden = true;
      button.setAttribute('aria-expanded', 'true');
      close.focus();
      if (!api.widget.status().loaded) {
        status.hidden = false;
        status.textContent = status.dataset.loading;
        api.widget.load();
        timer = setTimeout(() => { if (!api.widget.status().loaded) status.textContent = status.dataset.delayed; }, 12000);
      }
    });
    close.addEventListener('click', hide);
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  };
  if (window.HubSpotConversations) ready();
  else (window.hsConversationsOnReady = window.hsConversationsOnReady || []).push(ready);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rcl-cloud-fabric"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rcl-cloud-fabric')) {
  customElements.define('rcl-cloud-fabric', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const figures = [...this.querySelectorAll('[data-fabric-variant]')];
        const valid = id => figures.some(f => f.dataset.fabricVariant === String(id));
        const controls = [...document.querySelectorAll('[name="id"]')];
        const selected = controls.find(el => valid(el.value) && (el.type === 'radio' ? el.checked : el.tagName === 'SELECT'));
        const hidden = controls.find(el => valid(el.value) && el.type === 'hidden');
        const urlId = new URL(location.href).searchParams.get('variant');
        const id = selected?.value || hidden?.value || (valid(urlId) ? urlId : this.dataset.initial);
        const match = figures.find(f => f.dataset.fabricVariant === String(id));
        figures.forEach(f => { f.hidden = f !== match || f.hasAttribute('data-fabric-missing'); });
        this.toggleAttribute('data-missing', !match || match.hasAttribute('data-fabric-missing'));
      };
      this.onChange = () => { this.update(); setTimeout(this.update, 150); };
      document.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onChange);
      this.timer = setInterval(this.update, 400);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onChange);
      clearInterval(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rcl-live-edge-views"] && !Shopify.designMode) return;
  try {
    (function(){
 if(customElements.get('rcl-live-edge-gallery'))return;
 var selected;
 class RclLiveEdgeGallery extends HTMLElement{
  connectedCallback(){this.showVariant(selected || this.dataset.initialVariant);}
  showVariant(value){
   var panels=Array.from(this.querySelectorAll('[data-view-variant]'));
   var active=panels.find(function(p){return p.dataset.viewVariant===String(value)||p.dataset.viewTitle===String(value);});
   if(!active)return;
   selected=active.dataset.viewVariant;
   panels.forEach(function(p){p.hidden=p!==active;});
   this.hidden=!active.querySelector('figure');
  }
 }
 customElements.define('rcl-live-edge-gallery',RclLiveEdgeGallery);
 document.addEventListener('change',function(event){
  if(!event.target.closest('article.m6pr'))return;
  document.querySelectorAll('rcl-live-edge-gallery').forEach(function(g){g.showVariant(event.target.value);});
 },true);
 window.addEventListener('popstate',function(){
  var id=new URL(location.href).searchParams.get('variant');
  if(id)document.querySelectorAll('rcl-live-edge-gallery').forEach(function(g){g.showVariant(id);});
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rcl-mattress-gallery-toggle"] && !Shopify.designMode) return;
  try {
    (function(){
 function setup(){
  document.querySelectorAll('[data-mattress-gallery-toggle]').forEach(function(control){
   if(control.dataset.ready)return;
   var gallery=control.parentElement.querySelector('#main-product-slider');
   var button=control.querySelector('button');
   if(!gallery||!button||gallery.children.length<=4)return;
   control.dataset.ready='true';
   var label=button.textContent;
   gallery.classList.add('rcl-mattress-collapsed');
   control.hidden=false;
   button.addEventListener('click',function(){
    var expanded=button.getAttribute('aria-expanded')==='true';
    gallery.classList.toggle('rcl-mattress-collapsed',expanded);
    button.setAttribute('aria-expanded',String(!expanded));
    button.textContent=expanded?label:'Show fewer photos';
    if(expanded)gallery.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
   });
  });
 }
 setup();
 document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rcl-selected-variant-photo"] && !Shopify.designMode) return;
  try {
    (function(){
document.addEventListener('change',function(event){
 var root=event.target.closest('article.m6pr');
 if(!root)return;
 var data=root.querySelector('[data-rcl-variant-photos]');
 if(!data)return;
 var variants;
 try{variants=JSON.parse(data.textContent)}catch(error){return}
 var selected=variants.find(function(v){return String(v.id)===event.target.value||v.title===event.target.value});
 if(!selected||!selected.image)return;
 root.querySelectorAll('.l4pr-container .l4pr').forEach(function(gallery){
  gallery.querySelectorAll('a[data-zoom]').forEach(function(link){link.href=selected.image});
  gallery.querySelectorAll('picture img').forEach(function(img){img.removeAttribute('srcset');img.src=selected.image;img.alt=selected.title});
 });
},true);
})();
  } catch(e) { console.error(e); }
})();

})();
